import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header align--flex-start" }
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"row ma--bottom-1\"><div class=\"col-xl-5\"></div><div class=\"col-xl-7\"><div class=\"pa--right-1\"><h1>MegaData<span class=\"text--style-italic\"></span></h1></div></div></div>", 1)
const _hoisted_9 = { class: "row ma--bottom-1" }
const _hoisted_10 = { class: "col-xl-2" }
const _hoisted_11 = { class: "form-field__checkboxlist" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", { class: "text--align-center" }, "Geo Target", -1)
const _hoisted_13 = ["value", "id"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "form--field__textarea ma--bottom-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "text--align-center" }, "Google Search Keyword or Phrase", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "text--align-center" }, "How many Records", -1)
const _hoisted_18 = {
  class: "stepper--bar__content--label__info--message",
  style: {"border-bottom":"none","font-size":"12px"}
}
const _hoisted_19 = { class: "col-xl-10" }
const _hoisted_20 = { class: "pa--y-1 pa--right-1" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "text--style-italic",
  style: {"font-size":"80%"}
}, null, -1)
const _hoisted_23 = { class: "form-checkbox" }
const _hoisted_24 = ["id", "onClick"]
const _hoisted_25 = ["for"]
const _hoisted_26 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_27 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"100%","height":"0"} }, null, -1)
const _hoisted_29 = { style: {"width":"100%"} }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { style: {"display":"inline-block"} }, "Premium Data", -1)
const _hoisted_31 = {
  key: 0,
  class: "form-checkbox",
  style: {"display":"inline-block","min-width":"0","margin-left":"10px"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-size":"small","color":"gray"},
  for: "selectAllFields"
}, "Select All", -1)
const _hoisted_33 = {
  key: 0,
  class: "pa--x-0 pa--bottom-1 col-3"
}
const _hoisted_34 = { class: "form-checkbox" }
const _hoisted_35 = ["id", "checked", "onClick", "disabled"]
const _hoisted_36 = ["for"]
const _hoisted_37 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_38 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_39 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MegaDataConfirm = _resolveComponent("MegaDataConfirm")!
  const _directive_focus = _resolveDirective("focus")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.toggleMegaDataConfirm)
              ? (_openBlock(), _createBlock(_component_MegaDataConfirm, {
                  key: 0,
                  selectedFields: _ctx.fields,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModel($event)))
                }, null, 8, ["selectedFields"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateList, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStates) = $event)),
                          value: item,
                          id: index
                        }, null, 8, _hoisted_13), [
                          [_vModelCheckbox, _ctx.selectedStates]
                        ]),
                        _createElementVNode("label", { for: item }, _toDisplayString(item), 9, _hoisted_14)
                      ]))
                    }), 256))
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.googleSearchKeywords) = $event)),
                    placeholder: "Enter up to 10 Google Keywords, separated by commas.",
                    rows: "3",
                    cols: "23",
                    style: {"width":"100%"}
                  }, null, 512), [
                    [_vModelText, _ctx.googleSearchKeywords]
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form--field__input ma--bottom-1", {
                            'form-field--is-invalid': _ctx.v$.request.numberOfRecords.$error,
                            'form-field--is-active': !_ctx.v$.request.numberOfRecords.$invalid,
                          }])
                }, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    style: {"width":"100%"},
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.request.numberOfRecords) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.request.numberOfRecords],
                    [_directive_focus]
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.fieldsMessage), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (!_ctx.subscriptionMode)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_21, [
                        _createTextVNode("Included Data"),
                        _hoisted_22
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["row form-group--checkbox", { 'pa--y-2': _ctx.subscriptionMode }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (
                        item.leadFieldName != 'middleName' &&
                        item.leadFieldName != 'lastName' &&
                        item.credit == 0 ||
                        item.leadFieldName == 'email' ||
                        item.leadFieldName == 'city'
                      )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["pa--x-0 pa--bottom-1", {
                        'col-6': item.leadFieldName == 'firstName',
                        'col-3': item.leadFieldName != 'firstName',
                      }])
                            }, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("input", {
                                  id: 'field-' + index,
                                  type: "checkbox",
                                  checked: true,
                                  onClick: ($event: any) => (item.value = !item.value),
                                  disabled: false
                                }, null, 8, _hoisted_24),
                                _createElementVNode("label", {
                                  for: 'field-' + index
                                }, [
                                  _createTextVNode(_toDisplayString(item.leadFieldName == "firstName"
                              ? "First Name, Middle Initial & Last Name"
                              : item.displayName) + " ", 1),
                                  (!_ctx.subscriptionMode)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (item.leadFieldName != 'email')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "(Free)"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_27, "(1 credit)"))
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_25)
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      (!_ctx.subscriptionMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("input", {
                              id: "selectAllFields",
                              type: "checkbox",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectAllFields && _ctx.selectAllFields(...args)))
                            }),
                            _hoisted_32
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (
                        item.credit > 0 &&
                        item.leadFieldName != 'email' &&
                        item.leadFieldName != 'city'
                      )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("input", {
                                  id: 'field-' + index,
                                  type: "checkbox",
                                  checked: item.value,
                                  onClick: ($event: any) => (item.value = !item.value),
                                  disabled: item.disabled
                                }, null, 8, _hoisted_35),
                                _createElementVNode("label", {
                                  for: 'field-' + index
                                }, [
                                  _createTextVNode(_toDisplayString(item.leadFieldName == "firstName"
                              ? "Full Name"
                              : item.displayName) + " ", 1),
                                  (!_ctx.subscriptionMode)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (item.credit > 0)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, "(" + _toDisplayString(item.credit) + " credit)", 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_38, "(Free)"))
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_36)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn--secontary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                  }, " Cancel "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn--primary",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, " Submit ")
                ])
              ])
            ])
          ])
        ])
      ]))
}